import axios from 'axios'
import { Message } from 'element-ui'
// import store from '@/store'
import { getToken } from '@/utils/auth'
// import router from '@/router'
// import { logout } from "@/api/user"
// import { proxy, unProxy } from 'ajax-hook'

// var baseURLStr = window.g.BASE_URL

// create an axios instance
const service = axios.create({
  // baseURL: baseURLStr,
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    //if (store.getters.token)
    if (process.env.NODE_ENV === 'production') {
      config.url = '/apiv2' + config.url;
    } else {
      config.url = '/apiv2' + config.url;
    }
    if (getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    // if (error.response && (error.response.status === 401 || error.response.status === 403)) {
    //   // Token失效，执行相应操作
    //   alert('登录状态已过期，请重新登录')
    // }

    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
 
    if (res.code === 401 || res.code === 403) {
      // Token失效，执行相应操作
      alert('登录状态已过期，请重新登录')
      return Promise.reject(error)
    } else {
      return res;
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

// proxy({
//   onRequest: (config, handler) => {
//     if (window.location.host.indexOf('192.168.60.164') > -1) {
//       if (config.url.toString().search('https://vdata.amap.com') != -1) {
//         config.url = 'http://192.168.60.164:8080/vdata' + config.url.split('vdata.amap.com/')[1];
//         console.log("config.urlvdata====:", config.url)
//       } else if (config.url.toString().search('https://restapi.amap.com') != -1) {
//         config.url = 'http://192.168.60.164:8080/restapi' + config.url.split('restapi.amap.com/')[1];
//         console.log("config.urlrestapi====:", config.url)
//       } else if (config.url.toString().search('https://vector.amap.com') != -1) {
//         config.url = 'http://192.168.60.164:8080/vector' + config.url.split('vector.amap.com/')[1];
//         console.log("config.urlvector====:", config.url)
//       } else if (config.url.toString().search('https://lbs.amap.com') != -1) {
//         config.url = 'http://192.168.60.164:8080/lbs' + config.url.split('lbs.amap.com/')[1];
//         console.log("config.urllbs====:", config.url)
//       } else if (config.url.toString().search('https://webapi.amap.com') != -1) {
//         config.url = 'http://192.168.60.164:8080/webapi' + config.url.split('webapi.amap.com/')[1];
//         console.log("config.urlwebapi====:", config.url)
//       } else if (config.url.toString().search('http://vdata.amap.com') != -1) {
//         config.url = 'http://192.168.60.164:8080/vdata' + config.url.split('vdata.amap.com/')[1];
//         console.log("config.urlvdata====:", config.url)
//       } else if (config.url.toString().search('http://restapi.amap.com') != -1) {
//         config.url = 'http://192.168.60.164:8080/restapi' + config.url.split('restapi.amap.com/')[1];
//         console.log("config.urlrestapi====:", config.url)
//       } else if (config.url.toString().search('http://vector.amap.com') != -1) {
//         config.url = 'http://192.168.60.164:8080/vector' + config.url.split('vector.amap.com/')[1];
//         console.log("config.urlvector====:", config.url)
//       } else if (config.url.toString().search('http://lbs.amap.com') != -1) {
//         config.url = 'http://192.168.60.164:8080/lbs' + config.url.split('lbs.amap.com/')[1];
//         console.log("config.urllbs====:", config.url)
//       } else if (config.url.toString().search('http://webapi.amap.com') != -1) {
//         config.url = 'http://192.168.60.164:8080/webapi' + config.url.split('webapi.amap.com/')[1];
//         console.log("config.urlwebapi====:", config.url)
//       }
//     }
//     handler.next(config);
//   },
//   onError: (err, handler) => {
//     handler.next(err)
//   },
//   onResponse: (response, handler) => {
//     if (response.response.indexOf(`"code":-100`) > 0) {
//       MessageBox.confirm('登录已过期，请重新登录！', '提示', {
//         confirmButtonText: '确定',
//         showCancelButton: false,
//         closeOnClickModal: false,
//         closeOnPressEscape: false,
//         showClose: false,
//         type: 'warning'
//       }).then(action => {
//         if (action === 'confirm') {
//           store.dispatch('user/logout')
//           router.go(`/login`)
//         }
//       })
//     } else if (response.response.indexOf(`"loginCode":10002`) > 0) {
//       MessageBox.confirm('用户名或密码错误，请重新登录！', '提示', {
//         confirmButtonText: '确定',
//         showCancelButton: false,
//         closeOnClickModal: false,
//         closeOnPressEscape: false,
//         showClose: false,
//         type: 'warning'
//       }).then(action => {
//         if (action === 'confirm') {
//           return;
//         }
//       })
//     } else if (response.response.indexOf(`"loginCode":10001`) > 0) {
//       MessageBox.confirm('用户名或密码错误，请重新登录！', '提示', {
//         confirmButtonText: '确定',
//         showCancelButton: false,
//         closeOnClickModal: false,
//         closeOnPressEscape: false,
//         showClose: false,
//         type: 'warning'
//       }).then(action => {
//         if (action === 'confirm') {
//           return;
//         }
//       })
//     }
//     handler.next(response)
//   }
// })


export default service
